import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
export function BenefitsSection() {
  return <>
      <section className="py-20 px-4 bg-gray-50" data-id="element-1">
        <div className="max-w-4xl mx-auto" data-id="element-2">
          <h2 className="text-4xl md:text-5xl font-black text-center mb-12 uppercase" data-id="element-3">
            Después de aplicar esto vas a lograr:
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-4">
            {['Saber EXACTAMENTE qué hacer cada día', 'Generar conversaciones reales con clientes', 'Tener un sistema repetible', 'Vender sin depender del algoritmo', 'Crear ingresos predecibles'].map((benefit, i) => <div key={i} className="flex items-center gap-4 bg-white p-6 rounded-xl shadow-md border border-gray-200" data-id="element-5">
                <CheckCircle2Icon className="w-8 h-8 text-green-500 flex-shrink-0" data-id="element-6" />
                <span className="text-xl font-bold text-gray-800" data-id="element-7">
                  {benefit}
                </span>
              </div>)}
          </div>
        </div>
      </section>

      <section className="py-20 px-4 bg-white border-y-8 border-black" data-id="element-8">
        <div className="max-w-4xl mx-auto text-center" data-id="element-9">
          <p className="text-red-600 font-black tracking-widest uppercase mb-4 text-xl" data-id="element-10">
            ESTO ES CLAVE:
          </p>

          <div className="text-2xl md:text-4xl font-black text-gray-400 line-through decoration-red-500 decoration-4 mb-8 space-y-2" data-id="element-11">
            <p data-id="element-12">Las ventas no vienen del talento</p>
            <p data-id="element-13">No vienen de la suerte</p>
            <p data-id="element-14">No vienen del algoritmo</p>
          </div>

          <p className="text-3xl md:text-5xl font-black text-black mb-10 uppercase" data-id="element-15">
            Vienen de esto:
          </p>

          <div className="flex flex-col md:flex-row justify-center items-center gap-6 mb-16" data-id="element-16">
            <div className="bg-yellow-400 text-black font-black text-2xl py-4 px-8 rounded-full transform -rotate-2 shadow-lg" data-id="element-17">
              ✔ Repetición
            </div>
            <div className="bg-yellow-400 text-black font-black text-2xl py-4 px-8 rounded-full transform rotate-1 shadow-lg" data-id="element-18">
              ✔ Consistencia
            </div>
            <div className="bg-yellow-400 text-black font-black text-2xl py-4 px-8 rounded-full transform -rotate-1 shadow-lg" data-id="element-19">
              ✔ Acción diaria
            </div>
          </div>

          <div className="bg-black text-white p-8 md:p-12 rounded-2xl shadow-2xl relative" data-id="element-20">
            <span className="absolute -top-6 left-1/2 -translate-x-1/2 text-6xl" data-id="element-21">
              💡
            </span>
            <p className="text-xl md:text-2xl font-bold text-gray-400 mb-4 uppercase tracking-wider" data-id="element-22">
              Tal como se explica en el sistema:
            </p>
            <p className="text-3xl md:text-5xl font-black text-yellow-400 leading-tight" data-id="element-23">
              “El vendedor que más vende no es el más inteligente, es el más
              constante”
            </p>
          </div>
        </div>
      </section>
    </>;
}